import { SuggestionOption } from '@modules/common/components/MultiColumnAutoComplete/MultiColumnAutoCompleteExample/types';
import { AI_FILTER, EqlFieldName } from '@modules/common/constants';
import {
  EqlFieldValueType,
  IntegrationChannelType,
  ObjectType,
  QueryBuilderGroup,
  QueryBuilderGroupType,
  Source,
} from 'generated/graphql';

interface getGroupOptionsOptions {
  queryBuilderGroup?: QueryBuilderGroup[];
  shouldRemoveFileUploadPrefix: boolean;
}

const fixGroupDisplayName = (
  displayName: string,
  shouldRemoveFileUploadPrefix: boolean,
) => {
  let modifiedDisplayName = displayName;
  if (shouldRemoveFileUploadPrefix) {
    modifiedDisplayName = modifiedDisplayName.replaceAll(
      `${IntegrationChannelType.FileUpload}-`,
      '',
    );
  }
  return modifiedDisplayName.trim();
};

export function getGroupOptions({
  queryBuilderGroup,
  shouldRemoveFileUploadPrefix,
}: getGroupOptionsOptions) {
  const options: SuggestionOption[] = [];
  const groupOrder: string[] = [];

  queryBuilderGroup?.forEach((group) => {
    const groupDisplayName = fixGroupDisplayName(
      group.displayName,
      shouldRemoveFileUploadPrefix,
    );

    group.options.forEach((option) => {
      const valueDisplayName =
        (option.field.field === EqlFieldName.Source &&
        shouldRemoveFileUploadPrefix &&
        option.value?.value.startsWith(Source.FileUpload)
          ? option.value?.displayName.replaceAll(
              IntegrationChannelType.FileUpload,
              '',
            )
          : option.value?.displayName) ?? '';

      options.push({
        ...option,
        value: option.value
          ? {
              ...option.value,
              displayName: valueDisplayName.trim(),
            }
          : option.value,
        id:
          group.id === AI_FILTER
            ? AI_FILTER
            : `${option.field.field}_${option.value?.value ?? ''}`,
        groupID: group.id,
        groupDisplayName,
        groupType: group.type,
      });
    });

    if (group.hasMore) {
      const getField = () => {
        if (group.type === QueryBuilderGroupType.Value) {
          return group.options[0].field;
        }

        return group.field;
      };

      options.push({
        id: `${group.id}_more`,
        groupID: group.id,
        groupDisplayName,
        groupType: group.type,
        field: getField() ?? {
          field: group.id,
          displayName: group.displayName,
          isMultiValue: true,
          valueType: EqlFieldValueType.String,
          objectType: ObjectType.Feedback,
        },
        isCompleteMatch: false,
      });
    }

    groupOrder.push(group.id);
  });

  return { options, rows: [groupOrder] };
}
